import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;

  .documents-main {
    min-width: 0;
  }

  .documents-scroll {
    flex: 1;
    min-height: 0;
  }

  .documents-empty {
    max-width: 900px;
    border-color: ${(props) => props.theme.$gray300};
  }

  .documents-empty-title {
    color: ${(props) => props.theme.$dark};
    font-size: 18px;
    font-weight: 600;
  }

  .analyst-link {
    vertical-align: baseline;

    .material-icons-outlined {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }

  .documents-progress {
    border-color: ${(props) => props.theme.$gray300};

    .progress {
      height: 6px;
    }
  }

  .documents-counters {
    border-left: 1px solid ${(props) => props.theme.$gray300};

    .material-icons {
      font-size: 16px;
    }
  }

  .documents-searching {
    position: absolute;
    inset: 0;
    z-index: 2;
    background: ${(props) => props.theme.$black}cc;
    color: ${(props) => props.theme.$white};
    font-size: 16px;
    font-weight: 600;
  }

  .documents-add-pane {
    width: 600px;
    max-width: 45%;
  }
`;
